// #1241 — Shared Modal to display the original (unstripped) mail HTML in a
// sandboxed iframe. Used by Claims-Communication-Tab + Cases-Detail.
import { useEffect } from 'react';
import { X } from 'lucide-react';

export default function MailOriginalModal({ open, onClose, html, subject }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const srcDoc = `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>body{margin:0;font-family:Arial,Helvetica,sans-serif;background:#fff;color:#1A1A2E}</style></head><body>${html || '<p style="padding:24px;color:#6B7280">(Kein HTML verfügbar)</p>'}</body></html>`;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4" onClick={onClose}>
      <div
        className="w-full max-w-3xl bg-surface-card border border-line-card rounded-card shadow-xl overflow-hidden flex flex-col"
        style={{ maxHeight: '85vh' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-line-card">
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-[12px] font-semibold text-content truncate">📧 Original-E-Mail</span>
            {subject && <span className="text-[12px] text-content-tertiary truncate">— {subject}</span>}
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-surface-hover text-content-tertiary hover:text-content"
            aria-label="Schließen"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <iframe
          title="Original-E-Mail"
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          srcDoc={srcDoc}
          className="flex-1 w-full bg-white"
          style={{ minHeight: '60vh', border: 0 }}
        />
      </div>
    </div>
  );
}
